/** Fase 2 (W1): Inicio en secciones, selector de período, barra superior con índices y franja de ambiente. */
export const inicioEs = {
  inicio: {
    kicker: 'Resumen',
    titulo: 'Hola, {{nome}}',
    indicadores: 'Indicadores',
    semIndicadores: 'Instala módulos para ver indicadores aquí.',
    secoes: { financeiro: 'Finanzas', comercial: 'Comercial', operacao: 'Operación', pessoas: 'Personas y aprendizaje', sistema: 'Sistema' },
    etiqueta: { hoje: 'Hoy', agora: 'Ahora', periodo: 'Período' },
    base: { caixa: 'Caja', competencia: 'Mes de referencia', emissao: 'Emisión' },
    verDetalhes: 'Ver detalles',
    delta: {
      acima: '{{pct}} por encima del período anterior',
      abaixo: '{{pct}} por debajo del período anterior',
      igual: 'Igual al período anterior',
      semAnterior: 'Sin valor en el período anterior',
      anterior: 'Período anterior: {{valor}}',
    },
    motivo: { erro: 'No se pudo calcular este valor ahora. Inténtalo de nuevo en unos instantes.', tempo: 'El cálculo superó el tiempo límite. Inténtalo de nuevo en unos instantes.' },
    vazio: { padrao: 'Aún sin datos', lista: 'Nada que mostrar ahora', grafico: 'Sin movimientos en el período' },
    acoesRapidas: 'Acciones rápidas',
    acoes: {
      fatura: 'Nueva factura',
      contaPagar: 'Nueva cuenta por pagar',
      lancamento: 'Nuevo movimiento',
      cliente: 'Nuevo cliente',
      oportunidade: 'Nueva oportunidad',
      contrato: 'Nuevo contrato',
      agendamento: 'Agendar reunión',
      tarefa: 'Nueva tarea',
      compra: 'Nueva compra',
      pedidoCompra: 'Nuevo pedido de compra',
      produto: 'Nuevo producto',
      funcionario: 'Nuevo empleado',
      curso: 'Nuevo curso',
    },
    grafico: {
      entradas: 'Entradas',
      saidas: 'Salidas',
      saldo: 'Saldo acumulado',
      previsto: 'Saldo previsto',
      previstoLegenda: 'Saldo previsto (con las cuentas abiertas)',
      aria: 'Flujo de caja del {{de}} al {{ate}}, saldo acumulado al final de {{saldo}}',
      tabela: 'Datos del gráfico de flujo de caja',
      data: 'Fecha',
      semana: 'Semana del {{data}}',
    },
    lista: {
      fatura: 'Por cobrar',
      conta_pagar: 'Por pagar',
      diasAtraso_one: '{{count}} día de atraso',
      diasAtraso_other: '{{count}} días de atraso',
      sem_categoria: 'Sin categoría',
      outras: 'Otras categorías',
      autor: { sistema: 'Sistema', chave: 'Clave de API' },
    },
    cards: {
      a_receber_semana: { rotulo: 'Por cobrar', partes: { vencido: 'Vencido', hoje: 'Vence hoy', proximos_7: 'Próximos 7 días' } },
      recebido_periodo: { rotulo: 'Cobrado en el período' },
      a_pagar: { rotulo: 'Por pagar', partes: { vencido: 'Vencido', hoje: 'Vence hoy', proximos_7: 'Próximos 7 días' } },
      pago_periodo: { rotulo: 'Pagado en el período' },
      saldo_contas: { rotulo: 'Saldo de las cuentas', subtitulo_one: '{{count}} cuenta activa', subtitulo_other: '{{count}} cuentas activas' },
      resultado_caixa: { rotulo: 'Resultado de caja', partes: { entradas: 'Entradas', saidas: 'Salidas' } },
      resultado_competencia: { rotulo: 'Resultado del mes (devengo)', partes: { entradas: 'Ingresos', saidas: 'Gastos' } },
      fluxo_caixa: { rotulo: 'Flujo de caja', valor: 'Saldo al final del período', partes: { entradas: 'Entradas en el período', saidas: 'Salidas en el período', previsto: 'Saldo previsto al final del período' } },
      faturamento_emitido: { rotulo: 'Facturación emitida' },
      despesas_categoria: { rotulo: 'Gastos por categoría', vazio: 'Ningún gasto pagado en el período' },
      proximos_vencimentos: { rotulo: 'Próximos vencimientos', vazio: 'Ningún vencimiento en los próximos 15 días' },
      maiores_devedores: { rotulo: 'Mayores deudores', vazio: 'Ningún cliente con cuentas vencidas' },
      conciliacao_pendente: { rotulo: 'Por conferir con el banco', partes: { entradas: 'Entradas por conferir con el banco', saidas: 'Salidas por conferir con el banco' } },
      oportunidades_abertas: { rotulo: 'Ventas en negociación', partes: { quantidade: 'Oportunidades abiertas' } },
      ganhas_periodo: { rotulo: 'Ganadas en el período', partes: { quantidade: 'Oportunidades ganadas', conversao: 'Tasa de conversión' } },
      conversas_nao_lidas: { rotulo: 'Conversaciones sin leer', partes: { minhas: 'Asignadas a mí', sem_dono: 'Sin responsable' } },
      clientes_ativos: { rotulo: 'Clientes activos', partes: { novos_periodo: 'Nuevos en el período' } },
      agenda_hoje: { rotulo: 'Agenda de hoy', subtitulo: 'Próxima a las {{hora}}' },
      estoque_abaixo_minimo: { rotulo: 'Stock por debajo del mínimo' },
      compras_a_receber: { rotulo: 'Compras por recibir', partes: { atrasados: 'Con entrega atrasada' } },
      funcionarios_ativos: { rotulo: 'Empleados activos', partes: { admissoes: 'Ingresos en el período', desligamentos: 'Bajas en el período' } },
      folha_ultima: { rotulo: 'Planilla', subtitulo: 'Neto del período {{mes}}', vazio: 'Aún no hay planilla cerrada' },
      documentos_vencendo: { rotulo: 'Documentos que vencen en 30 días', partes: { vencidos: 'Ya vencidos' } },
      treinamento_em_andamento: { rotulo: 'Capacitaciones en curso' },
      conectores_ativos: { rotulo: 'Conectores conectados', partes: { com_erro: 'Con error' } },
      atividade_recente: { rotulo: 'Actividad reciente', vazio: 'Aún no hay actividad registrada' },
      mrr: { rotulo: 'Ingreso mensual recurrente (MRR)', partes: { pausado: 'Ingreso recurrente en pausa', a_iniciar: 'Ingreso recurrente por iniciar' }, vazio: 'Todavía no hay contratos recurrentes' },
      reajustes_pendentes: { rotulo: 'Reajustes pendientes' },
      minhas_tarefas: { rotulo: 'Mis tareas abiertas', partes: { atrasadas: 'Con plazo vencido', p1: 'Prioridad P1' } },
      cards_parados: { rotulo: 'Tarjetas detenidas hace más de 7 días', partes: { esperando_pessoa: 'Esperando decisión', mais_14: 'Detenidas hace más de 14 días' } },
      novidades: { rotulo: 'Novedades', naoVistas_one: '{{count}} novedad que aún no has visto', naoVistas_other: '{{count}} novedades que aún no has visto', emDia: 'Ya viste todas las novedades', nova: 'Nueva', verTodas: 'Ver todas las novedades' },
    },
  },
  periodo: {
    escolher: 'Elegir período',
    atual: 'Período: {{rotulo}}',
    atalhos: {
      hoje: 'Hoy',
      semana: 'Esta semana',
      mes: 'Mes actual',
      mes_passado: 'Mes pasado',
      '30_dias': 'Últimos 30 días',
      trimestre: 'Trimestre actual',
      ano: 'Año actual',
      personalizado: 'Personalizado',
    },
    de: 'Desde',
    ate: 'Hasta',
    aplicar: 'Aplicar',
    invalido: 'Elige la fecha inicial antes de la final, con un máximo de 3 años.',
    aplicarPeriodo: 'Aplicar período',
    mes: 'Mes',
    mesAno: '{{mes}} / {{ano}}',
    mesInvalido: 'Elige un mes válido.',
    rotuloAbas: 'Tipo de período',
    abas: { atalhos: 'Atajos', mes: 'Mes específico', periodo: 'Período' },
  },
  // U15 F8: atalho rápido do topo.
  atalho: {
    abrir: 'Registro rápido',
    titulo: 'Registro rápido',
    oQue: 'Qué registrar',
    novaTarefa: 'Nueva tarea',
    mensagemEquipe: 'Mensaje al equipo',
    salvarTarefa: 'Guardar tarea',
    enviarMensagem: 'Enviar mensaje',
    escolha: 'Elige la persona o el canal',
    para: 'Para',
    mensagem: 'Mensaje',
    canal: 'canal',
    tarefaCriada: 'Tarea creada',
    verTarefa: 'Ver tarea',
    mensagemEnviada: 'Mensaje enviado',
    abrirConversa: 'Abrir conversación',
  },
  barra: {
    titulo: 'Barra superior',
    indices: 'Índices',
    regiao: 'Índices económicos del Banco Central de Brasil',
    nomes: { igpm: 'IGP-M', ipca: 'IPCA', inpc: 'INPC', selic: 'SELIC' },
    mes12: '12m',
    acumulado: 'acumulado en 12 meses: {{valor}}',
    atualizado: 'Actualizado el {{data}}',
    vazio: 'Los índices del Banco Central aparecen aquí después de la primera sincronización.',
    erro: 'Índices no disponibles ahora.',
    ocultar: 'Ocultar índices',
    mostrar: 'Mostrar índices',
    atualizarAgora: 'Actualizar índices ahora',
    atualizacaoPedida: 'Actualización pedida al Banco Central. Los índices aparecen en un momento.',
    recolherMenu: 'Contraer menú lateral',
    expandirMenu: 'Expandir menú lateral',
  },
  ambiente: {
    rotulo: 'Aviso de ambiente',
    homologacao: 'Ambiente de homologación. Datos de prueba.',
    staging: 'Ambiente de staging. Datos de prueba.',
    sandbox: 'Sandbox: datos de prueba, nada aquí afecta la operación real.',
  },
  // Lote 19 (item 13): pantalla dividida.
  divisao: {
    abrirAoLado: 'Abrir al lado',
    abrirEmAba: 'Abrir en otra pestaña del panel',
    tituloAbrir: 'Abrir esta pantalla al lado (Ctrl+Alt+flecha derecha)',
    barra: 'Pantalla dividida',
    painel: 'Panel {{n}}',
    divisoria: 'Divisor entre los paneles',
    proporcao: 'Panel 1 con el {{p}} % del ancho',
    trocar: 'Intercambiar lados',
    fechar: 'Cerrar el panel {{n}}',
    opcoesDoItem: 'Opciones de {{item}}',
    // Lista del 30/10 B (ítem 2 de la ficha del Principal): el botón fijo de la barra superior.
    botaoBarra: 'Pantalla dividida',
    dicaLigar: 'Divide la pantalla en dos paneles, cada uno con su subsistema (Ctrl+Alt+flecha derecha)',
    dicaDesligar: 'Vuelve a un solo panel',
  },
};
